import { api } from './axios';

/**
 * API для работы с онлайн-статусами пользователей (Presence)
 */
export const presenceApi = {
    /**
     * Получить статус одного пользователя
     * @param {string} userId - ID пользователя
     * @returns {Promise<Object>} { userId, username, isOnline, lastActivity }
     */
    getStatus: async (userId) => {
        try {
            const { data } = await api.get(`/presence/${userId}/status`);
            return data;
        } catch (error) {
            console.error(`[presenceApi.getStatus] Failed for ${userId}:`, error.message);
            throw error;
        }
    },

    /**
     * Получить статусы нескольких пользователей
     * @param {string[]} userIds - Массив ID пользователей
     * @returns {Promise<Array>} Массив { userId, username, isOnline, lastActivity }
     */
    getStatuses: async (userIds) => {
        try {
            const { data } = await api.post('/presence/statuses', userIds);
            return data;
        } catch (error) {
            console.error('[presenceApi.getStatuses] Failed:', error.message);
            throw error;
        }
    },

    /**
     * Получить всех онлайн-пользователей
     * @returns {Promise<Array>}
     */
    getOnline: async () => {
        try {
            const { data } = await api.get('/presence/online');
            return data;
        } catch (error) {
            console.error('[presenceApi.getOnline] Failed:', error.message);
            throw error;
        }
    },

    /**
     * Получить количество онлайн-пользователей
     * @returns {Promise<{count: number}>}
     */
    getOnlineCount: async () => {
        try {
            const { data } = await api.get('/presence/online/count');
            return data;
        } catch (error) {
            console.error('[presenceApi.getOnlineCount] Failed:', error.message);
            throw error;
        }
    }
};
